"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var kb_event_1 = require("./kb-event");
exports.getKeyFromKeyboardEvent = kb_event_1.getKeyFromKeyboardEvent;
exports.getKeyFromInputEvent = kb_event_1.getKeyFromInputEvent;
exports.default = { getKeyFromKeyboardEvent: kb_event_1.getKeyFromKeyboardEvent, getKeyFromInputEvent: kb_event_1.getKeyFromInputEvent };
//# sourceMappingURL=index.js.map